import { plainToInstance, Type } from 'class-transformer'
import moment from 'moment'
import { Entity } from '@core/entities/entity'
import { User } from '@core/entities/user'
import { IAuditCheckIn } from './IAuditCheckIn'

export class AuditCheckIn extends Entity<IAuditCheckIn> {
  checkInSessionId: number
  @Type(() => User)
  user?: User
  signatureId?: number
  expectedCheckOutOn: string

  public static new(payload: unknown): AuditCheckIn {
    return plainToInstance(AuditCheckIn, payload)
  }

  public getFormattedExpectedCheckOutOn(): string {
    return moment(this.expectedCheckOutOn).format('DD MMM YYYY HH:mm')
  }
}
